// extracted by mini-css-extract-plugin
export default {"box":"UserComponent_box__GQxdg"};